import resolvePromise from '../helper/resolved_promise';
import { FilterAvailableOptionsActions } from '../constants/filter_available_options/filter_available_options_actions';
import Dispatcher from '../dispatcher';

function updateAvailableFilterOptionsAction(updatedFilterOptions) {
    Dispatcher.handleFilterAvailableOptionsAction({
        type: FilterAvailableOptionsActions.UPDATE_FILTER_AVAILABLE_OPTIONS_ACTION,
        payload: updatedFilterOptions
    });

    return resolvePromise();
}

export {
    updateAvailableFilterOptionsAction
};